import { createTheme } from "@mui/material/styles";

export const colors = {
  default: {
    primary: "#6BB7CD",
    primaryPressed: "#62A2B5",
    primaryDsiabled: "#B0D6E0",
    secondary: "#FA9884",
    additional: "#D9EDFA",
    background: "#F9F9F9",
    darkGrey: "#353535",
    mediumGrey: "#5F5F5F",
    lightMediumGrey: "#B4B4B4",
    inputPlaceholder: "#9F9F9F",
    inputField: "#F6F6F6",
    white: "#FFFFFF",
    error: "#FF6D6D",
  },
};

export const sizes = {
  width: {
    drawer: 224,
  },
  drawer: {
    width: "224px",
    widthCollapsed: "68px",
  }
};

export const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
    fontSize: 14,
    htmlFontSize: 16,
    fontWeightLight: 400,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  palette: {
    error: {
      main: colors.default.error,
    },
    primary: {
      main: colors.default.primary,
    },
    secondary: {
      main: colors.default.secondary,
    }
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h1: {
          color: colors.default.darkGrey,
          fontWeight: 700,
          fontSize: "28px",
          lineHeight: "42px",
        },
        h2: {
          color: colors.default.mediumGrey,
          fontWeight: 700,
          fontSize: "24px",
          lineHeight: "36px",
        },
        h3: {
          color: colors.default.darkGrey,
          fontWeight: 600,
          fontSize: "22px",
          lineHeight: "33px",
        },
        h4: {
          color: colors.default.lightMediumGrey,
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "27px",
        },
        h5: {
          color: colors.default.primary,
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "24px",
        },
        h6: {
          color: colors.default.primary,
          fontWeight: 600,
          fontSize: "14px",
          lineHeight: "21px",
        },
        body1: {
          color: "#424242",
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "24px",
        },
        body2: {
          color: "#424242",
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "21px",
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {

        },
        standardError: {
          backgroundColor: "transparent",
          color: colors.default.error,
          padding: "0",
        },
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          border: "1px solid transparent",
          backgroundColor: colors.default.inputField,
          "&:hover": {
            border: `1px solid ${colors.default.primary}`,
          },
          "&.Mui-error": {
            border: `1px solid ${colors.default.error}`,
          },
          "&.Mui-focused.Mui-error": {
            border: `1px solid ${colors.default.error}`,
          },
          "&.Mui-focused": {
            border: `1px solid ${colors.default.primary}`,
          }
        },
        notchedOutline: {
          border: "none",
        },
        disabled: {},
      },
      defaultProps: {
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          paddingTop: 14,
          marginBottom: 8,
          marginTop: 8,
          "& input": {
            padding: 16,
          },
          "& .MuiInputBase-multiline textarea": {
            minHeight: "124px"
          }
        },
      },
      defaultProps: {
        InputProps: {
          style: {
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "24px",
            color: colors.default.mediumGrey,
          }
        },
        InputLabelProps: {
          shrink: true,
          style: {
            left: -10,
            top: 0,
            margin: 0,
            padding: 0,
            background: "transparent",
            fontSize: "14px",
            lineHeight: "21px",
            fontWeight: 500,
            color: colors.default.mediumGrey,
          }
        },
        FormHelperTextProps: {
          style: {
            marginLeft: 4,
          }
        }
      },
    },
    MuiButtonBase: {
      defaultProps: {
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          whiteSpace: "nowrap",
          textTransform: "none",
          fontWeight: 600,

          "&.MuiButton-contained": {
            color: colors.default.white,
            fontSize: "16px",
            lineHeight: "24px",
            textTransform: "none",
            width: "236px",
            height: "56px",
          },
          "&.MuiButton-outlined": {
            fontSize: "16px",
            lineHeight: "24px",
            textTransform: "none",
            width: "236px",
            height: "56px",
            borderWidth: 2,
          },
          "&.MuiButton-containedPrimary": {
            backgroundColor: colors.default.primary,
          },
          "&.MuiButton-containedPrimary.Mui-disabled": {
            backgroundColor: colors.default.primaryDsiabled,
          },
          "&.outlined-primary-pin": {
            color: colors.default.primary,
            background: "#F1F9FC",
            border: "none",

            "& .MuiListItemText-root .MuiTypography-root": {
              color: colors.default.primary,
            }
          }
        }
      },
      defaultProps: {

      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          border: "none",
          "& .MuiTypography-root": {
            fontFamily: "Poppins",
            color: colors.default.lightMediumGrey,
            fontStyle: "normal",
            fontWeight: 600,
          },
          "& .MuiToolbar-root .MuiTypography-root": {
            color: colors.default.primary,
          },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: `${sizes.width.drawer}px`, border: "none", },
          "& .drawer-nav__routes": {
            color: colors.default.lightMediumGrey,
            "& svg path": {
              fill: colors.default.lightMediumGrey,
            },
            "& .MuiListItem-root:hover": {
            },
            "& .MuiListItemButton-root": {
              margin: "6px",
              "& .MuiListItemIcon-root": {
                minWidth: "40px",
              }
            },
            "& .drawer-nav__route-active": {
              color: colors.default.primary,
              "& .MuiTypography-root": {
                color: colors.default.primary,
              },
              "& svg path": {
                fill: colors.default.primary,
              },
              "& .MuiListItemButton-root": {
                background: colors.default.background,
              }
            }
          },
        },
      },
      defaultProps: {}
    },
    MuiTable: {
      styleOverrides: {
        root: {
          minWidth: "auto !important",
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-root": {
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: "21px",
            color: "#969696",
          },
          '& .MuiTableRow-root > .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
          },
          '& .MuiTableRow-root > .MuiTableCell-root:last-child': {
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
          },
        },
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .MuiTableRow-root": {
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "14px",
            color: colors.default.mediumGrey,
          },
          "& .MuiTableRow-root:hover": {
            backgroundColor: "#F7F7F7",
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          border: 'none',
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          "& .MuiDialog-paper": {
            padding: "16px",
          },
          "& .MuiDialogContent-root": {
            textAlign: "center",
          },
          "& .MuiDialogContent-root .MuiDialogContentText-root": {
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "27px",
          }
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          "&.toolbar__row-list": {
            display: "flex",
            flexDirection: "row",
          
            "& .MuiListItem-root .MuiListItemText-root .MuiTypography-root": {
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "21px",
              whiteSpace: "nowrap",
            
              color: colors.default.lightMediumGrey,
            },
            "& .MuiButtonBase-root": {
              color: colors.default.lightMediumGrey,
              borderRadius: "8px",
            },
            "& .MuiButtonBase-root[color='primary']": {
              color: colors.default.primary,
              background: "#F1F9FC",
            
              "&  .MuiListItemText-root .MuiTypography-root": {
                color: colors.default.primary,
              }
            },
          },
          "&.line-list": {
            display: "flex",
            "& .MuiListItem-root": {
              minWidth: "90px",
              width: "auto",
            },
            "& .MuiListItem-root .MuiTypography-root": {
              color: colors.default.lightMediumGrey,
              fontFamily: 'Poppins',
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px"
            },
            "& .MuiListItemIcon-root": {
              minWidth: "18px",
              minHeight: "18px",
              marginRight: "8px",
              "& svg": {
                color: colors.default.primary,
              }
            },
            "& .MuiListItem-root .text-primary .MuiTypography-root": {
              color: colors.default.primary,
            },
            "& .MuiListItem-root .text-default .MuiTypography-root": {
              color: colors.default.lightMediumGrey,
            }
          }
        }
      }
    }
  }
}, {
  sizes,
  colors,
});

export type AppTheme = typeof theme & { sizes: typeof sizes, colors: typeof colors }

export default theme